import Badge from './Badge';

export default function Badges({ user }) {
  return (
    <div className="flex flex-wrap gap-x-2 gap-y-3 justify-center tablet:justify-start">
      {user.achievements.map((achievement) => (
        <Badge
          achievement={achievement}
          key={achievement.badge.id}
          user={user}
        />
      ))}
    </div>
  );
}
